import { useQuery } from "@tanstack/react-query";

/** Mirrors server `EnrichedProOffer` for the public marketing API. */
export type PublicProOffer = {
	offerId: string;
	stripePriceId: string;
	sortOrder: number;
	isBestValue: boolean;
	cardLabel: string;
	cardDescription: string | null;
	displayListAmountMajor: number | null;
	unitAmount: number;
	currency: string;
	recurringInterval: "month" | "year" | "week" | "day" | null;
	trialEligible: boolean;
	checkoutSubmitMessage: string | null;
};

export type PublicProOffersResponse = {
	offers: PublicProOffer[];
	hasSellableOffers: boolean;
};

export function publicProOffersQueryKey() {
	return ["billing", "public-pro-offers"] as const;
}

export function usePublicProOffers() {
	return useQuery({
		queryKey: publicProOffersQueryKey(),
		queryFn: async (): Promise<PublicProOffersResponse> => {
			const res = await fetch("/api/billing/public-offers");
			if (!res.ok) {
				throw new Error("Could not load plans.");
			}
			return res.json() as Promise<PublicProOffersResponse>;
		},
		staleTime: 60_000,
	});
}
